<template name="SecurityIndex">
  <div class="index-page">
    <div class="grid-container" :class="{'grid-overflow': this.newWareHouseShow || this.isBindCardModalShownLayout,'remove-item': this.midWidth}">
      <div class="grid-item">
      </div>
      <div class="grid-item nav-item" :class="{ 'remove-nav-item': this.midWidth }">
        <div class="coca-logo">
          <img v-show="!this.midWidth" src="../../assets/logo.png" alt="">
        </div>
        <div class="avatar" >
          <img v-show="!this.midWidth" :src="this.avatar" alt="user-avatar">
          <p v-show="!this.midWidth">{{ currentUser.userName }}{{ currentPostName ? `(${currentPostName})` : '' }}</p>
        </div>
        <div class="tab-container">
          <router-link class="tab-item home" :class="{ checked: pathname === 'index','remove-item': this.midWidth }" to="/security/index">
            <span v-show="!this.midWidth">首页</span>
          </router-link>
          <!-- <router-link class="tab-item all" :class="{ checked: pathname === 'invisitList' }" to="/security/invisitList">
            全部邀请
          </router-link> -->
          <router-link class="tab-item quick-notification" :class="{ checked: pathname === 'quickNotice','remove-item': this.midWidth }" to="/security/quickNotice">
            <span v-show="!this.midWidth">快捷通知</span>
          </router-link>
          <!-- <div class="tab-item registration">
            访客登记
          </div> -->
          <div class="tab-item scan" :class="{ 'remove-item': this.midWidth }" @click="scanQRCodeToDetail">
            <span v-show="!this.midWidth">扫码</span>
          </div>
        </div>
      </div>
      <div class="grid-item component-item" :class="{ 'remove-item': this.midWidth }">
        <div class="grid-item header-item" :class="{ 'remove-item': this.midWidth }" v-if="pathname === 'detailList'">
          <div class="back">
            <router-link to="/security/index">
              返回
            </router-link>
          </div>
          <div class="area-name detail-area-name">
          {{ this.invitationData.typeName }} {{ this.invitationData.areaName }}
          </div>
          <div class="btns">
            <div class="btn-item" :key="idx" v-for="(btnName, idx) in filteredBtnNames" v-show="btnName !== 'noCardExitButton'"
            @click="handleBtn(btnName)">
            {{ btnsNameObj[btnName] }}
            </div>
            <div class="btn-item collapsed" @click="toggleNoCardExit">
              ...
            </div>
            <div class="no-card-exit" v-show="isNoCardExitShown" @click="handleBtn('noCardExitButton')">
              无卡离开
            </div>
          </div>
        </div>
        <div class="grid-item header-item" :class="{ 'remove-item': this.midWidth }" v-else>
          <div class="area-name">
            访客系统
          </div>
          <div class="post-name" @click="isSelectPopShown = true">
            {{ securityGuardPost ? currentPostName : '选择门岗' }}
          </div>
        </div>
          <!-- component will be inserted here -->
          <indexSecurity v-if="pathname === 'index'" :postID="securityGuardPost"></indexSecurity>
          <invisitListSecurity v-else-if="pathname === 'invisitList'" :msg="pathname"></invisitListSecurity>
          <div class="detail-page"  :class="{'remove-item': this.midWidth}" v-else-if="pathname === 'detailList'">
            <div class="detail-left">
              <DetailLeftTop :routId="this.routId"
              :newDeviceLayout="this.midWidth"
              @isOwner="isOwnerStatus"
              @isCheckOwner="isCheckOwnerStatus"
              @trackingType="trackingTypeNumber"
              @invitationStatus="invitationStatusNumber"
              @isSecurity="isSecurity"
              @invitationDataLoaded="handleInvitationDataLoaded"
              @ifEnable="ifEnable"></DetailLeftTop>
              <inprogress :routId="this.routId" :newDeviceLayout="this.midWidth"></inprogress>
            </div>
            <div class="detail-right" :class="{'remove-item': this.midWidth}">
              <wareHouse :routId="this.routId" :newDeviceLayout="this.midWidth" :isGoodsListChecker="this.isGoodsListCheckerStatus" :inviteGoodsList="this.inviteGoodsList" @newWareHouseShow="newWareHouseShowModal" @deleteSecurityCheckGoods="deleteSecurityCheckGoods" ></wareHouse>
              <visitorList ref="visitorDataList"
              :isTicket="this.isOwner"
              :inviteId="this.routId"
              :isCheckOwner="this.isCheckOwner"
              :trackingType="this.trackingType"
              :inviteStatus="this.invitationStatus"
              :qrCode="qrCodeResult"
              :newDeviceLayout="this.midWidth"
              @inviteGoodsList="inviteGoodsListData"
              @scanQRCode="scanQRCode"
              @checkVisitorList='checkVisitorList'
              @getCheckInRes="qrCodeResult = ''"
              @isGoodsListChecker="isGoodsListChecker"
              @isBindCardModalShown="isBindCardModalShown"
              ></visitorList>
            </div>
          </div>
          <div v-else-if="pathname === 'quickNotice'" class="quickNotice">
            <quickNotice></quickNotice>
          </div>
        <div class="grid-item footer-item">
          版权©可口可乐
        </div>
      </div>

      <selectSecurityPost
        :currentPostId="securityGuardPost"
        :isSelectPopShown="isSelectPopShown"
        @getPostList="handleGetPostList"
        @closeSelectPop="isSelectPopShown = false"
        @setPost="handleSetPost"
      >
      </selectSecurityPost>
      <transition name="fade">
        <div class="visit-show" v-show="this.newWareHouseShow">
        <div class="wareHouse-view">
          <newWareHouse ref="detailDialog" :invitationId="this.routId" :carNumberList="this.carNumberList" @closeNewWarehouse="newWareHouseShow = !newWareHouseShow"></newWareHouse>
        </div>
        </div>
      </transition>
      <transition>
        <div v-show="this.showComfirmDelete">
          <tipModal ref="detailDialogShow"  :currentStatus="this.deleteInvitationId" :invitationId = "this.routId" @closeModal="showComfirmDelete = !showComfirmDelete"   :goodsListId="this.goodsListId"></tipModal>
        </div>
      </transition>
      <transition name="fade">
        <div class="visit-show noticeModal" v-show="this.noticeModal" @click="closeFun($event)">
        <div class="wareHouse-view">
          <notice  ref="noticeModal" @closeNotice="closeNotice" :checkVisitorList="this.checkVisitorLists"></notice>
        </div>
        </div>
      </transition>
      <transition name="fade">
        <alertModalSecurity
          v-if="pathname === 'detailList'"
          modalType="faceRecognition"
          :modalStatus="modalStatus"
          :modalTitle="modalTitle"
          :btnName="modalBtnName"
          :errMsg="modalErrMsg"
          :isModalShown="isModalShown"
          @closeSecurityModal="closeCheckoutModal"
          @executeOperation="btnStatus === 0 ? noCardCheckout(true) : btnStatus === 1 ? scanQRCodeCheckout() : closeCheckoutModal()">
        </alertModalSecurity>
      </transition>
      <transition name="fade">
        <alertModal
          v-if="pathname === 'detailList'"
          :isModalShown="isLeaveAlertShow"
          :modalTitle="leaveAlertTip"
          cancelBtnName="允许"
          confirmBtnName="拒绝"
          @cancel="checkoutType === 'noCardExitButton' ? noCardCheckout(false) : handleCheckout(false)"
          @confirm="isLeaveAlertShow = false">
        </alertModal>
      </transition>
      <alertModal
        :modalType="'simple'"
        :isModalShown="modalTip"
        :modalTitle="modalTipText"
        @cancel="modalTip = !modalTip">
      </alertModal>
      <alertModal
        :modalType="'simple'"
        :isModalShown="!isOverdue"
        :modalTitle="isOverdueTxt"
        @cancel="isOverdue = true">
      </alertModal>
    </div>
    <alertModal :modalType="'simple'" :isModalShown="scanToDetail" :modalTitle="scanToDetailText" @cancel="scanToDetail = !scanToDetail"></alertModal>
    <!-- Place this modal here, detect user device, if not valid, hide all content in page -->
    <alertModal
      :modalType="deviceTipModalType"
      :isModalShown="isDeviceTipShow"
      :modalTitle="deviceTip"
      @cancel="cancelDeviceModal">
    </alertModal>
    <alertModal
      :modalType="'simple'"
      :isModalShown="isShowAddError"
      :modalTitle="'没有在访访客'"
      @cancel="isShowAddError = !isShowAddError">
    </alertModal>
  </div>
</template>

<script type="text/javascript">
  import invisitListSecurity from '@/components/invisitListSecurity.vue';
  import indexSecurity from '@/components/indexSecurity.vue';
  import DetailLeftTop from '@/views/security/DetailLeftTop.vue';
  import inprogress from '@/views/security/Inprogress.vue';
  import wareHouse from '@/views/security/WareHouse.vue';
  import visitorList from '@/views/security/visitorList.vue';
  import selectSecurityPost from '@/components/selectSecurityPost.vue';
  import cokeStorage, { checkNested } from '@/utils/utils';
  import newWareHouse from '@/components/newWareHouse.vue';

  import { getVisitsecurityTotalCarNumberINfo, getSecurityUserInfo, getSecurityGuardPostButtonList, getticketidbyqrcode, scanQRCodeCheckOut, notCardCheckOut } from '@/utils/api';
  import tipModal from '@/components/tipModal.vue';
  import alertModalSecurity from '@/components/alertModalSecurity.vue';
  import alertModal from '@/components/alertModal.vue';
  import notice from '@/views/security/Notice.vue';
  import wx from 'weixin-js-sdk';
  import quickNotice from '@/views/security/QuickNotice.vue';
  import WXJS from '@/utils/wx';

  const MobileDetect = require('mobile-detect');

  const md = new MobileDetect(window.navigator.userAgent);
  const isNotTablet = md.tablet() === null;
  export default {
    name: 'SecurityIndex',
    components: {
      invisitListSecurity,
      indexSecurity,
      DetailLeftTop,
      inprogress,
      wareHouse,
      visitorList,
      selectSecurityPost,
      newWareHouse,
      tipModal,
      notice,
      quickNotice,
      alertModalSecurity,
      alertModal,
    },
    data() {
      return {
        pathname: 'index',
        routId: '',
        trackingType: -1,
        inviteGoodsList: [],
        isOwner: false,
        isCheckOwner: false,
        invitationStatus: -1,
        isTicket: false,
        newWareHouseShow: false,
        newWareHouseData: {},
        isSecurityStatus: false,
        showComfirmDelete: false,
        deleteInvitationId: '',
        goodsListId: '',
        noticeModal: false,
        checkVisitorLists: [],
        alertModal: false,
        // andy's code:
        currentUser: {},
        isSelectPopShown: false,
        securityGuardPost: 0,
        currentPostName: '',
        invitationData: {},
        btnsObj: {},
        btnsNameObj: {
          visitorNoticeButton: '访客告知',
          faceRecognitionButton: '人脸识别',
          bindNormalCardButton: '绑定普卡',
          printIDCardButton: '打印卡片',
          visitorsLeaveButton: '访客离开',
          noCardExitButton: '无卡离开',
        },
        isNoCardExitShown: false,
        qrCodeResult: '',
        // tip modal for ideal screen size
        isNotTablet: false,
        isDeviceTipShow: false,
        deviceTipModalType: '',
        deviceTip: '',
        // andy's code end

        // scan qrcode checkout start.
        checkoutType: '',
        modalStatus: false,
        modalTitle: '',
        modalBtnName: '',
        modalErrMsg: '',
        isModalShown: false,
        btnStatus: 0,
        checkoutQRCodeResult: '',
        isLeaveAlertShow: false,
        leaveAlertTip: '',
        // scan qrcode checkout end.
        isGoodsListCheckerStatus: false,
        modalTip: false,
        modalTipText: '',
        avatar: require('../../assets/images/default-avatar.png'),
        isWareHouse: false,
        isOverdue: true,
        isOverdueTxt: '',
        scanToDetail: false,
        scanToDetailText: '',
        midWidth: true,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        timer: false,
        isBindCardModalShownLayout: false,

        carNumberList: '',
        carNumberInfo: [],
        isShowAddError: false,
      };
    },
    computed: {
      filteredBtnNames() {
        const temp = [];
        const keys = Object.keys(this.btnsObj);
        keys.forEach((k) => {
          if (this.btnsObj[k]) {
            temp.push(k);
          }
        });
        return temp;
      },
    },
    created() {
      this.pathname = this.$route.params.pathname;
      const routeID = this.$route.params.id;
      this.routId = routeID;
      // console.log(this.routId);
 
      this.securityGuardPost = parseInt(cokeStorage.getItem('securityGuardPost'), 10);
      this.isSelectPopShown = this.securityGuardPost === 0;
      this.initData();
      // this.checkDevice();
      window.scrollTo(0,0);

      //get car number imformation
      getVisitsecurityTotalCarNumberINfo(routeID).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.model) {
            const carNumberLists = res.data.content.model;
            this.carNumberInfo = [];
            carNumberLists.forEach(item => {
              this.carNumberInfo.push(item);
            });
            this.carNumberList = '';
            this.carNumberList = JSON.stringify(this.carNumberInfo);
          }
        }
      });
    },
    watch: {
      $route() {
        this.pathname = this.$route.params.pathname;
        this.routId = this.$route.params.id;
        if (this.pathname && this.routId) {
          this.getBtns();
        }
        //get car number imformation
        const routeID = this.$route.params.id;
        getVisitsecurityTotalCarNumberINfo(routeID).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.model) {
              const carNumberLists = res.data.content.model;
              this.carNumberInfo = [];
              carNumberLists.forEach(item => {
                this.carNumberInfo.push(item);
              });
              this.carNumberList = '';
              this.carNumberList = JSON.stringify(this.carNumberInfo);
              console.log('所有车辆信息1');
              console.log(carNumberLists);
            }
          }
        });
      },
      currentUser(val, oldVal) {
        // may be useful to update component data
      },
      innerWidth(val) {
        if (!this.timer) {
          this.innerWidth = val;
          this.timer = true;
          let that = this;
          setTimeout(() => {
            that.timer = false;    
          },400)
        } 
      },
      innerHeight(val) {
        if (!this.timer) {
          this.innerHeight = val;
          this.timer = true;
          let that = this;
          setTimeout(() => {
            that.timer = false;
          },400)  
        }
      }
    },
    mounted() {
      const that = this;
      window.onresize = () => {
        return (() => {
          //window.screenWidth = document.body.clientWidth
          that.innerWidth = document.body.clientWidth;
          that.innerHeight = window.innerHeight;
          // that.checkDevice();
        })()
      } 
    },
    methods: {
      checkDevice() {
        const isCurrentSizeOK =   this.innerWidth < 700;
        const isHorizontalOK = (this.innerWidth < this.innerHeight) && this.innerHeight >= 700;
        const isrowOk = this.innerWidth >= 700 && this.innerWidth < 960;
        this.isNotTablet = true;
        // if (isNotTablet) {
        //   this.isDeviceTipShow = true;
        //   this.deviceTip = '请使用 Pad 访问保安系统';
        //   this.deviceTipModalType = 'none-function';
        //   this.isNotTablet = false;
        // } else 
        if (isrowOk) {
          this.midWidth = true;
        } else if (isHorizontalOK) {
          this.isDeviceTipShow = true;
          this.deviceTip = '建议横屏使用';
          this.deviceTipModalType = 'simple';
          this.midWidth = true;
        } else if (isCurrentSizeOK) {
          this.midWidth = true;
          this.isDeviceTipShow = true;
          this.deviceTip = '请使用较大尺寸的 Pad 访问保安系统';
          this.deviceTipModalType = 'simple';
        } else {
          this.midWidth = false;
        }
      },
      scanQRCode() {
        const self = this;
        WXJS.getWXSign().then(() => {
          wx.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1,
            scanType: ['qrCode', 'barCode'],
            success(res) {
              self.qrCodeResult = res.resultStr; // store res in data and may be useful for child component
            },
            error(res) {
              alert(`error:${ res }`);
              if (res.errMsg.indexOf('function_not_exist') > 0) {
                alert('版本过低请升级');
              }
            },
          });
        });
      },
      scanTo(qrCode) {
        getticketidbyqrcode(qrCode).then((res) => {
          if (res.data.status == '001') {
            if (checkNested(res, 'data', 'content', 'model')) {
              if (res.data.content.status === 1) {
                const id = res.data.content.model;
                this.$router.push({ path: `/security/detailList/${id}` });
              } else {
                this.scanToDetail = true;
                this.scanToDetailText = res.data.content.message;
              }
            }
          } else {
            this.scanToDetail = true;
            this.scanToDetailText = res.data.message;
          }  
        });
      },
      scanQRCodeToDetail() {
        const that = this;
        WXJS.getWXSign().then(() => {
          wx.scanQRCode({
            onlyFromCamera: false,
            needResult: 1,
            scanType: ['qrCode', 'barCode'],
            success(res) {
              const qrCode = res.resultStr;
              that.scanTo(qrCode);
            },
            error(res) {
              alert(`error:${ res }`);
              if (res.errMsg.indexOf('function_not_exist') > 0) {
                alert('版本过低请升级');
              }
            },
          });
        });
      },
      handleBtnName(isCard) {
        const t = this;
        if (isCard) {
          t.modalBtnName = '下一个';
          t.btnStatus = 1;
        } else {
          t.checkVisitorLists.shift();
          if (t.checkVisitorLists.length) {
            t.modalBtnName = '下一个';
            t.btnStatus = 0;
          } else {
            t.modalBtnName = '确定';
            t.btnStatus = 2;
          }
        }
      },
      handleCheckoutData(res) {
        const t = this;
        const isCard = t.checkoutType === 'visitorsLeaveButton';
        t.isLeaveAlertShow = false;
        t.leaveAlertTip = '';
        t.isModalShown = false;
        t.modalTitle = '';
        if (checkNested(res, 'data', 'content', 'model')) {
          const { status, model, message } = res.data.content;
          if (status === 1) {
            t.modalStatus = true;
            t.modalTitle = '出门成功';
            t.modalErrMsg = message;
            t.isModalShown = true;
            t.handleBtnName(isCard);
          } else if (status === 2) {
            if (res.data.content.model !== null) {
              t.isLeaveAlertShow = true; // show alert: agree/refuse
              t.leaveAlertTip = model;
            } else {
              t.modalStatus = false;
              t.modalTitle = '出门失败';
              t.modalErrMsg = message;
              t.isModalShown = true;
              t.handleBtnName(isCard);
            }
          } else {
            t.modalStatus = false;
            t.modalTitle = '出门失败';
            t.modalErrMsg = res.data.content.message;
            t.isModalShown = true;
            t.handleBtnName(isCard);
          }
        }
      },
      handleCheckout(isFirst) {
        const t = this;
        const dataObj = {
          ticketId: t.routId,
          qrCode: t.checkoutQRCodeResult,
          isContinueVerification: !isFirst,
        };
        scanQRCodeCheckOut(dataObj).then((res) => {
          this.handleCheckoutData(res);
        });
      },
      scanQRCodeCheckout() {
        const t = this;
        // hide modal first when tap next
        t.isModalShown = false;
        t.modalTitle = '';
        WXJS.getWXSign().then(() => {
          wx.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1,
            scanType: ['qrCode', 'barCode'],
            success(res) {
              t.checkoutQRCodeResult = res.resultStr;
              t.handleCheckout(true);
            },
            error(res) {
              if (res.errMsg.indexOf('function_not_exist') > 0) {
                alert('版本过低请升级');
              }
            },
          });
        });
      },
      noCardCheckout(isFirst) {
        const t = this;
        const dataObj = {
          ticketId: t.routId,
          visitorId: t.checkVisitorLists[0],
          isContinueVerification: !isFirst,
        }
        notCardCheckOut(dataObj).then((res) => {
          this.handleCheckoutData(res);
        });
      },
      closeCheckoutModal() {
        window.location.reload();
      },
      isOwnerStatus(status) {
        this.isOwner = status;
      },
      isCheckOwnerStatus(status) {
        this.isCheckOwner = status;
      },
      inviteGoodsListData(data) {
        this.inviteGoodsList = data;
      },
      trackingTypeNumber(data) {
        this.trackingType = data;
      },
      invitationStatusNumber(data) {
        this.invitationStatus = data;
        this.routId = this.$route.params.id;
      },
      initData() {
        // current login user info:
        getSecurityUserInfo().then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.currentUser = res.data.content.model;
            this.avatar = this.currentUser.avatar === '' ? this.avatar : this.currentUser.avatar;
          }
        });
        if (this.pathname && this.routId) {
          this.getBtns();
        }
      },
      handleGetPostList(data) {
        if (data) {
          this.currentPostName = data.postName;
        }
      },
      handleSetPost(data) {
        if (data.status === true) {
          cokeStorage.setItem('securityGuardPost', data.id);
          this.isSelectPopShown = false;
          this.securityGuardPost = data.id;
          this.currentPostName = data.postName;
          this.initData();
        }
      },
      handleInvitationDataLoaded(data) {
        if (data) {
          this.invitationData = data;
        }
        
      },
      getBtns() {
        // get detail operation btns
        getSecurityGuardPostButtonList().then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            // console.log(res.data.content.model);
            this.btnsObj = res.data.content.model; // notice: this is an object, not array
          }
        });
      },
      toggleNoCardExit() {
        this.isNoCardExitShown = !this.isNoCardExitShown;
      },
      handleBtn(btnName) {
        /**
         visitorNoticeButton
         faceRecognitionButton
         bindNormalCardButton
         printIDCardButton
         visitorsLeaveButton
         noCardExitButton
         */
        if (btnName === 'faceRecognitionButton') {
          // handle faceRecognition
          this.$refs.visitorDataList.handleFaceRecognition();
        } else if (btnName === 'visitorNoticeButton') {
          if (this.checkVisitorLists.length) {
            this.$refs.noticeModal.loadModal(this.checkVisitorLists, false);
            this.noticeModal = true;
          } else {
            this.modalTip = true;
            this.modalTipText = '至少选择一个访客';
          }
          
        } else if (btnName === 'bindNormalCardButton') {
          this.$refs.visitorDataList.handleBindOrPrint(1);
        } else if (btnName === 'visitorsLeaveButton') {
          this.checkoutType = btnName;
          this.scanQRCodeCheckout();
        } else if (btnName === 'noCardExitButton') {
          if (this.checkVisitorLists.length) {
            this.checkoutType = btnName;
            this.noCardCheckout(true);
          } else {
            this.modalTip = true;
            this.modalTipText = '至少选择一个访客';
          }
        } else if (btnName === 'printIDCardButton') {
          this.$refs.visitorDataList.handleBindOrPrint(2);
        }
      },
      newWareHouseShowModal(status, checkGoodsObj, isWareHouse) {
        // no car and people imformation
        console.log('数据');
        console.log(this.carNumberInfo);
        if(this.carNumberInfo == "" && !checkGoodsObj) {
          this.isShowAddError = true;
          return;
        }
        window.scrollTo(0,0)
        this.newWareHouseShow = status;
        this.newWareHouseData = checkGoodsObj;
        this.isWareHouse = isWareHouse;
        this.$refs.detailDialog.loadDialogData(checkGoodsObj, this.isSecurityStatus, 0, this.isWareHouse);
      },
      isSecurity(status) {
        this.isSecurityStatus = status;
      },
      deleteSecurityCheckGoods(showComfirmDelete, id, showObj, goodsListId) {
        this.showComfirmDelete = showComfirmDelete;
        this.deleteInvitationId = id;
        this.goodsListId = goodsListId;
        this.$refs.detailDialogShow.loadDialogData(showObj);
      },
      closeNotice(status) {
        this.noticeModal = status;
        window.location.reload();
      },
      checkVisitorList(list) {
        this.checkVisitorLists = list;
      },
      closeFun(ev) {
        ev.returnValue = false;
        this.noticeModal = false;
      },
      isGoodsListChecker(status) {
        this.isGoodsListCheckerStatus = status;
      },
      // method to close device tips modal
      cancelDeviceModal() {
        this.isDeviceTipShow = false;
        //this.isDeviceTipShow = isNotTablet;
      },
      ifEnable(status) {
        this.isOverdueTxt = '该邀请已结束';
        this.isOverdue = status;
      },
      isBindCardModalShown(status) {
        this.isBindCardModalShownLayout = status;
      }
    },
  };
</script>
<style lang="scss" scoped>
  .grid-container {
    // display: grid;
    grid-template-columns: 4.6% 20.5% 70.3% 4.6%;
    grid-template-rows: 58px auto 45px;
    height: 100%;
    display: flex;
    padding-left: 4.6%;
    &.grid-overflow {
      overflow: hidden;
      height: 100vh;
    }
    &.remove-item {
      padding-left: 0;
    }
  }
  .grid-item {
    &.nav-item {
      position: fixed;
      z-index: 10;
      grid-column-start: 2;
      grid-column-end: 3;
      grid-row-start: 1;
      grid-row-end: 4;
      display: flex;
      min-width: 20.5%;
      max-width: 20.5%;
      flex-direction: column;
      box-shadow: 0 2px 11px 0 rgba(226, 226, 226, 0.35);
      min-height: 100%;
      &.remove-nav-item {
        max-width: 5.5%;
        min-width: 5.5%;
      }
      .coca-logo {
        padding: 13px;
        text-align: center;
        height: 58px;
        border-bottom: 1px solid #f0f1f2;
        img {
          width: 87px;
        }
      }
      .avatar {
        padding: 35px 0;
        text-align: center;
        border-bottom: 1px solid #f0f1f2;
        img {
          width: 70px;
          border-radius: 50%;
        }
        p {
          font-size: 14px;
          margin-top: 15px;
          color: #4a4a4a;
          margin-bottom: 0;
        }
      }
      .tab-container {
        font-size: 14px;
        font-weight: 500;
        .tab-item {
          display: block;
          padding: 20px 30px;
          background: url(../../assets/images/security/home.png) no-repeat  right center;
          background-origin: content-box;
          background-size: 15px;
          position: relative;
          text-decoration: none;
          color: #929292;
          &.remove-item {
            padding: 30px 10px;
            background: url(../../assets/images/security/home.png) no-repeat  center;
            background-size: 15px;
          }
          &.checked {
            background-color: #f9f9f9;
            background-image: url(../../assets/images/security/home-checked.png);
            color: #e42029;
            &:before {
              content: '';
              width: 4px;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              background: linear-gradient(4deg, #f36443, #e42029);
            }
          }
          &.all {
            background-image: url(../../assets/images/security/invite.png);
            &.checked {
              background-image: url(../../assets/images/security/invite-checked.png);
            }
          }
          &.quick-notification {
            background-image: url(../../assets/images/security/send.png);
            &.checked {
              background-image: url(../../assets/images/security/send-checked.png);
            }
          }
          &.registration {
            background-image: url(../../assets/images/security/security-code.png);
            &.checked {
              background-image: url(../../assets/images/security/security-code.png);
            }
          }
          &.scan {
            color: #e42029;
            background-image: url(../../assets/images/security/scan.png);
          }
          &:last-of-type {
            font-weight: normal;
          }
        }
      }
    }
    &.header-item {
      position: fixed;
      z-index: 10;
      background: #fff;
      width: 76%;
      grid-column-start: 3;
      grid-column-end: 5;
      grid-row-start: 1;
      grid-row-end: 2;
      min-height: 58px;
      padding: 0 30px;
      box-shadow: 0 2px 11px 0 rgba(226, 226, 226, 0.35);
      display: flex;
      justify-content: space-between;
      align-items: center;
      // push copyright to bottom
      &.remove-item {
        width: 95%;
      }
      & + div {
        min-height: calc(100vh - 103px);
      }
      .area-name {
        font-weight: bold;
        font-size: 16px;
        &.detail-area-name {
          flex-grow: 1;
          margin-left: 30px;
        }
      }
      .back {
        background: url(../../assets/images/security/back.png) no-repeat left center;
        padding-left: 25px;
        background-size: 20px;
        a {
          color: #4a4a4a;
          font-size: 14px;
        }
      }
      .btns {
        border-radius: 3px;
        border: solid 0.6px #e42029;
        font-size: 16px;
        color: #e42029;
        display: flex;
        position: relative;
        .btn-item {
          border-right: solid 0.6px #e42029;
          padding: 10px;
          &.collapsed {
            border-right: none;
            width: 1px;
            word-break: break-word;
            line-height: 6px;
            font-size: 16px;
            padding: 10px 15px 0 12px;
          }
        }
        .no-card-exit {
          position: absolute;
          right: 0;
          top: 100%;
          width: 97px;
          height: 54px;
          border-radius: 1px;
          background-color: #ffffff;
          box-shadow: 0 2px 11px 0 rgba(226, 226, 226, 0.35);
          color: #929292;
          text-align: center;
          line-height: 54px;
          right: -20px;
        }
      }
      .post-name {
        font-size: 14px;
        padding: 0 15px;
         background-image: url(../../assets/images/security/location.png),
                           url(../../assets/images/arrow-copy-down.png);
         background-repeat: no-repeat, no-repeat;
         background-size: 12px;
         background-position: left center, right center;
      }
    }
    &.footer-item {
      // grid-column-start: 3;
      // grid-column-end: 4;
      // grid-row-start: 3;
      // grid-row-end: 4;
      color: #c4c4c4;
      text-align: center;
      line-height: 45px;
      font-size: 12px;
    }
    &.component-item {
      margin-left: 21.5%;
      grid-column-start: 3;
      grid-column-end: 4;
      grid-row-start: 2;
      grid-row-end: 3;
      flex-grow: 1;
      // overflow-x: hidden;
      // overflow-y: auto;
      // display: flex;
      // flex-direction: column;
      &.remove-item {
        margin-left: 5.5%;
      }
    }
  }

  .detail-page {
    margin-top: 58px;
    padding: 30px;
    display: flex;
    flex-grow: 1;
    &.remove-item {
      display: block;
    }
  }
  .detail-left {
    //width: 290px;
  }
  .detail-right {
    margin-left: 20px;
    width: 100%;
    height: auto;
    &.remove-item {
      margin-left: 0;
    }
  }

  .visit-show {
    height: 100%;
    .wareHouse-view {
      border-radius: 10px;
    }
    .ware-house {
      min-height: 600px;
      border-radius: 10px;
      background-color: #fff;
      border-radius: 10px;
      width: 600px;
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      overflow-y: auto;
      .new-invisit-content {
        height: calc(100vh - 200px);
      }
    }
  }
  .quickNotice {
    margin: 30px 30px 0 30px;
    flex-grow: 1;
    margin-top: 58px;
  }
</style>
